// Notification utility for StudySnap
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const scheduleNotification = (task, reminderTime) => {
  if (!reminderTime) return null;

  const [hours, minutes] = reminderTime.split(':');
  const reminderDate = new Date(task.deadline);

  // If task has a specific time, use the reminder time on the deadline date
  // Otherwise, use reminder time on deadline date
  reminderDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);

  const now = new Date();
  const timeUntilReminder = reminderDate.getTime() - now.getTime();

  if (timeUntilReminder <= 0) {
    console.log('Reminder time is in the past');
    return null;
  }

  // Schedule the notification
  const timeoutId = setTimeout(() => {
    showNotification(task);
  }, timeUntilReminder);

  return timeoutId;
};

export const showNotification = (task) => {
  if (Notification.permission !== 'granted') {
    console.log('Notification permission not granted');
    return;
  }

  const subjects = JSON.parse(localStorage.getItem('studysnap_subjects') || '[]');
  const subject = subjects.find(s => s.id === task.subjectId);

  const notification = new Notification('StudySnap Reminder', {
    body: `Don't forget: ${task.title}${subject ? ` (${subject.name})` : ''}`,
    icon: '/logo192.png',
    badge: '/logo192.png',
    tag: `task-${task.id}`,
    requireInteraction: true,
    actions: [
      {
        action: 'view',
        title: 'View Task'
      }
    ]
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
  };

  // Auto-close after 10 seconds
  setTimeout(() => {
    notification.close();
  }, 10000);
};

export const initializeNotifications = () => {
  // Request permission when the app loads
  requestNotificationPermission();

  // Set up notification scheduling for existing tasks
  const tasks = JSON.parse(localStorage.getItem('studysnap_tasks') || '[]');
  const activeTimeouts = {};

  tasks.forEach(task => {
    if (task.reminderTime && !task.completed) {
      const timeoutId = scheduleNotification(task, task.reminderTime);
      if (timeoutId) {
        activeTimeouts[task.id] = timeoutId;
      }
    }
  });

  return activeTimeouts;
};

export const clearNotificationTimeout = (timeoutId) => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
};
